import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import api from './api'
import localStorage from './utils/localStorage'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/reset.css'// 样式初始化
import '@/assets/style/index.css'// 媒体监听样式
import '@/assets/style/iconfont.css'// iconfont样式
import '@/utils/eldialogMove'// 对话框移动
import Router from 'vue-router'
import JsonExcel from 'vue-json-excel'// 导出excel插件
// import * as echarts from 'echarts'
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
// Vue.use(VueDirectiveImagePreviewer, {
//   background: {
//     color: "#000"
//   },
//   cursor: 'pointer',
//   clickMethod: 'doubleClick'
// })
import PrintTwo from '@/utils/printTwo'
Vue.use(PrintTwo)
Vue.component('downloadExcel', JsonExcel)
// require('./mock')//mock数据
const routerPush = Router.prototype.push
// Uncaught (in promise)报错
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.config.productionTip = false
Vue.use(ElementUI)// 饿了么插件
// Vue.prototype.$echarts = echarts
// Vue.use(echarts)// echarts图标插件
Vue.use(api)// api方法挂载到全局
Vue.use(localStorage)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js